var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLock = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 31,
  height: 29,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#lock_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#223B90",
  d: "M2.441 3A2.275 2.275 0 0 0 .166 5.275v4.745c0 .604.24 1.182.667 1.609l.184.184a2.275 2.275 0 0 0 1.608.666h.541c.961 0 1.74-.779 1.74-1.74H25.76c0 .961.779 1.74 1.74 1.74h.54c.604 0 1.183-.24 1.61-.666l.183-.184a2.275 2.275 0 0 0 .667-1.609V5.275A2.275 2.275 0 0 0 28.225 3H2.44Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2CBE96",
  d: "M7.75 5.014v19.32a2.275 2.275 0 0 0 2.275 2.275H20.82a2.275 2.275 0 0 0 2.275-2.275V5.014A2.275 2.275 0 0 0 20.82 2.74H10.025A2.275 2.275 0 0 0 7.75 5.015Z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 15.588,
  cy: 15.127,
  r: 4.804,
  fill: "#1A725A"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m15.435 16.665-.574-1.384a.568.568 0 0 0-.243-.25c.442-.135.663-.448.663-.94 0-.29-.08-.547-.242-.768-.194-.253-.548-.38-1.06-.38H12.53v3.722h.915V15.12h.153c.108 0 .178.013.21.04a.418.418 0 0 1 .114.178l.542 1.327h.971Zm-1.99-1.87v-1.52h.404c.162 0 .289.08.38.242.092.162.138.346.138.55a.927.927 0 0 1-.138.518.431.431 0 0 1-.38.21h-.404ZM16.648 13.946l-.25-.194h-.422v4.143l.907-.121V16.68c.183.038.364.057.542.057.825 0 1.238-.51 1.238-1.53 0-1.019-.416-1.529-1.246-1.529-.254 0-.51.09-.769.267Zm.235 2.33v-2.038a.958.958 0 0 1 .259-.049c.415 0 .623.35.623 1.052 0 .701-.197 1.052-.591 1.052-.13 0-.227-.006-.291-.016Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3863F0",
  d: "M2.441.5A2.275 2.275 0 0 0 .166 2.775v7.245c0 .604.24 1.182.667 1.609l.184.184a2.279 2.279 0 0 0 3.889-1.609V9H25.76v1.204a2.278 2.278 0 0 0 3.89 1.609l.183-.184a2.275 2.275 0 0 0 .667-1.609V2.775A2.275 2.275 0 0 0 28.225.5H2.44Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "lock_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.166.327H30.5v27.679H.166z"
})))));
export default SvgLock;